// AdminNeedsYou.tsx — (TF-6b-1; planning 10-16 20:53) the admin's door to "Needs you" for ANY run: the Run Inspector and the
// growth arc's video panel (TF-7's pilots are series runs on the growth account, with no video page). The same card as the
// video page; the answer goes through /api/admin/runs/:runId/needs-input (ingest, the run's own account's key). Nothing
// shows while the run waits on no question; a failed read is said (never an empty card).
import { useCallback, useEffect, useState } from "react";
import { apiGet, apiPost } from "@/api/client.ts";
import { NeedsYouCard } from "./NeedsYouCard.tsx";
import type { NeedsInputView } from "@/lib/needs-input.ts";

export const adminNeedsInputApi = {
  get: (runId: string) => apiGet<{ needsInput: NeedsInputView | null }>(`/admin/runs/${runId}/needs-input`),
  answer: (runId: string, choice: string, questionId: string | null) =>
    apiPost<{ ok: boolean }>(`/admin/runs/${runId}/needs-input`, { choice, ...(questionId ? { questionId } : {}) }),
};

export function AdminNeedsYou({ runId, onAnswered }: { runId: string; onAnswered?: () => void }) {
  const [ni, setNi] = useState<NeedsInputView | null>(null);
  const [readErr, setReadErr] = useState<string | null>(null);
  const load = useCallback(() => {
    adminNeedsInputApi.get(runId).then((r) => { setNi(r.needsInput); setReadErr(null); })
      .catch((e) => setReadErr(String((e as Error)?.message ?? e)));   // catch-reason: the error is shown in place of the card
  }, [runId]);
  useEffect(() => { load(); const t = setInterval(load, 15_000); return () => clearInterval(t); }, [load]);
  if (readErr) return <div style={{ color: "#b91c1c", fontSize: 13, margin: "8px 0" }}>The run's question couldn't be read: {readErr}</div>;
  if (!ni) return null;
  return (
    <div style={{ margin: "10px 0" }}>
      <NeedsYouCard ni={ni} admin answer={(choice, questionId) => adminNeedsInputApi.answer(runId, choice, questionId)}
        onAnswered={() => { load(); onAnswered?.(); }} onChanged={load} />
    </div>
  );
}
